<span class="hideOnMobile">
    <button class="transparent" (click)="showTableConfigDialog()" hisImage="brush">
        <span>{{'de.his.javang.edit.table' | hisUi}}</span>
    </button>

    @if (tableConfigDialogVisible()) {
        <p-dialog
            styleClass="fieldsetBgYellow"
            [responsive]="true"
            [modal]="true"
            [blockScroll]="true"
            [visible]="tableConfigDialogVisible()"
            (visibleChange)="tableConfigDialogVisible.set($event)"
            (onHide)="cancel()"
            [header]="'tableConfig.title' | hisUi">

            <!-- Buttons above -->
            <div>
                <button type="button" (click)="apply()">{{saveButtonLabel() | hisUi}}</button>
                <button type="button" (click)="cancel()">{{cancelButtonLabel() | hisUi}}</button>
                @if (!disableResetButton()) {
                    <button type="button" (click)="reset()">{{resetButtonLabel() | hisUi}}</button>
                }
            </div>
            
            <div class="clearer"></div>

            <!-- Frozen columns -->
            @if (enableFrozenColumns()) {
                <div class="columnFullSize">
                    <p-panel [header]="'tableConfig.fixColumns' | hisUi">
                        * {{'treeTableConfig.chooseFixColumns' | hisUi}}
                        <fieldset class="fieldsetGroup">
                            <legend #content class="legendTag">{{'tableConfig.fixColumns' | hisUi}}</legend>
                            <div class="optionsInline">
                                @for (option of frozenColumnOptions; track option) {
                                    <input type="radio" [id]="`frozenColItem_${$index}`" name="frozenCol" [value]="option.value" [(ngModel)]="uiModel.frozenCol">
                                    <label [for]="`frozenColItem_${$index}`">{{option.label | hisUi}}</label>
                                }
                            </div>
                        </fieldset>
                    </p-panel>
                </div>
            }

            <!-- Column selection (hiddenCols) -->
            @if (columns().length > 0) {
                <div class="columnHalf">
                    <p-panel [header]="'tableConfig.chooseColumns' | hisUi">
                        * {{'tableConfig.chooseColumnsSubtitle' | hisUi}}
                        @for (col of uiModel.columnConfigs; track col) {
                        <div>
                            <his-plam [label]="col.label | hisUi">
                                <input #content type="checkbox" [(ngModel)]="col.visible" binary="true">
                            </his-plam>
                        </div>
                        }
                    </p-panel>
                </div>
            }

            <!-- Paginator -->
            @if (enablePaginatorConfig()) {
                <div class="columnHalf">
                    <p-panel [header]="'tableConfig.naviBefore' | hisUi">
                        <his-plam [label]="'tableConfig.naviBefore' | hisUi">
                            <input #content type="checkbox" [(ngModel)]="uiModel.naviBefore" binary="true">
                        </his-plam>
                        <his-plam [label]="'tableConfig.naviAfter' | hisUi">
                            <input #content type="checkbox" [(ngModel)]="uiModel.naviAfter" binary="true">
                        </his-plam>
                
                    </p-panel>
                </div>
            }

            <!-- Reorderable columns -->
            @if (enableReorderableColumns()) {
                <div class="columnHalf">
                    <p-panel header="{{'tableConfig.columnMove' | hisUi}}">
                        <his-plam class="reorderableColumnsPanel" [label]="'tableConfig.columnMoveBtns' | hisUi">
                            <input #content type="checkbox" [(ngModel)]="uiModel.columnsReorderable" binary="true">
                        </his-plam>
                    </p-panel>
                </div>
            }

            <!-- Zeilen pro Seite (global) -->
            @if (!disablePersist()) {
                <div class="columnHalf">
                    <p-panel [header]="'tableConfig.globalPageSizeDefault' | hisUi">
                        <his-plam [label]="'tableConfig.globalPageSizeDefault' | hisUi">
                            <input #content
                                #pageSizeModel="ngModel"
                                type="text"
                                [(ngModel)]="uiModel.defaultTablePageSize"
                                [hisIntegerMin]="minRows"
                                [hisIntegerMax]="maxRows()"
                                class="inputWidth100">
                        </his-plam>
                    </p-panel>
                </div>
            }

            <div class="clearer"></div>

            <!-- Buttons below -->
            <div>
                <button type="button" (click)="apply()">{{saveButtonLabel() | hisUi}}</button>
                <button type="button" (click)="cancel()">{{cancelButtonLabel() | hisUi}}</button>
                @if (!disableResetButton()) {
                    <button type="button" (click)="reset()">{{resetButtonLabel() | hisUi}}</button>
                }
            </div>
        </p-dialog>
    }
</span>
